/**
 * Onde o caminhão fica no mapa, dentre as posições mais novas do frete.
 *
 * A captura de 5 min aceita qualquer precisão — é o piso que garante registro —, e parado debaixo de
 * telhado o Android entrega a posição da antena, a centenas de metros. Seguir sempre a mais nova faz o
 * caminhão parado pular até lá. A regra é a da `lastPosition` no `app-core-api`
 * (`src/utils/ultima-posicao.util.ts`), com os mesmos números, para o painel e o link do cliente não
 * mostrarem o caminhão em lugares diferentes.
 */

/** Imprecisa é acima disto. Sem `accuracy` — formato antigo — conta como precisa. */
const PRECISAO_MAXIMA_M = 100;

/** A imprecisa só vence quando não há posição precisa até este tanto mais velha que ela. */
const SEGURA_POSICAO_PRECISA_MS = 20 * 60 * 1000;

function imprecisa(posicao) {
  return (
    typeof posicao?.accuracy === "number" &&
    posicao.accuracy > PRECISAO_MAXIMA_M
  );
}

function millis(valor) {
  const n = Number(valor);
  return Number.isFinite(n) ? n : null;
}

/** Recebe as posições da mais nova para a mais velha, na ordem de `timestamp` da escuta. */
export function posicaoDoCaminhao(posicoes) {
  const maisNova = posicoes?.[0] ?? null;
  if (!maisNova || !imprecisa(maisNova)) return maisNova;

  const maisNovaMs = millis(maisNova.timestamp);
  const precisa = posicoes.find((posicao) => {
    const ms = millis(posicao?.timestamp);
    return (
      !imprecisa(posicao) &&
      maisNovaMs !== null &&
      ms !== null &&
      maisNovaMs - ms < SEGURA_POSICAO_PRECISA_MS
    );
  });

  return precisa ?? maisNova;
}
